import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/highlands-ranch-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Highlands Ranch", "highlands-ranch"),
  component: () => (
    <CityDigitalMarketingPage
      city="Highlands Ranch"
      slug="highlands-ranch"
      intro="Highlands Ranch is one of the largest planned communities in the country — and the densest home-services market in the south Denver corridor. We help Highlands Ranch companies dominate Google, the Map Pack, and AI search from our Colorado Springs HQ."
      whyUs={[
        "South Denver corridor specialists — we know the Highlands Ranch Town Center, Backcountry, and University Park trade areas",
        "Hyper-local SEO targeting all four Highlands Ranch villages plus surrounding HOAs",
        "Owner-led strategy from Chris — not a Denver agency that treats south metro as overflow",
      ]}
      nearby={[
        { name: "Lone Tree", to: "/lone-tree-digital-marketing" },
        { name: "Centennial", to: "/centennial-seo" },
        { name: "Greenwood Village", to: "/greenwood-village-digital-marketing" },
        { name: "Castle Rock", to: "/castle-rock-digital-marketing" },
        { name: "Parker", to: "/parker-digital-marketing" },
      ]}
      testimonial={{
        quote:
          "We were the underdog against three bigger Denver competitors. Chris's SEO and site got us into the Map Pack within four months.",
        role: "Home Services Owner",
        city: "Highlands Ranch",
      }}
      industryLinks={industryLinksFor("Highlands Ranch")}
    />
  ),
});
